<template>
<div>
  <div class="top">
    <FullSearch v-model="params.keyword"
                :showHot="false"
                @search="getSearchList"/>
  </div>
  <div class="search-list">
    <div class="tabs-container">
      <el-tabs class="tabs" v-model="params.docType" @tab-click="getSearchList">
        <el-tab-pane :label="doc.docTypeDesc +'（'+doc.count+'）'"
                     v-for="(doc,index) in docTypes"
                     :name="doc.docType"
                     :key="index"/>
      </el-tabs>
    </div>

    <div class="list" v-loading.lock="loading">
      <template v-if="searchList.length">
        <p class="result">共为您找到 {{total}} 个搜索结果</p>
        <div class="row"
             @click="gotoDetail(row)"
             v-for="(row, index) in searchList"
             :key="index"
        >
          <p class="search-title">{{ row.title }}</p>
          <p class="search-desc">{{ row.intro }}</p>
          <p class="search-time">
            <span>{{ row.cate_name || row.docTypeDesc || docTypeMap[row.docType] || docTypeMap[params.docType] }}</span>
            <span>更新时间</span>
            <span>{{ row.last_time }}</span>
          </p>
        </div>
      </template>
      <el-empty v-else></el-empty>

    </div>
    <div class="pagination">
      <el-pagination layout="total,prev, pager, next,jumper"
                     background
                     :total="total"
                     :page-size="params.page_size"
                     @current-change="handleCurrentChange"/>
    </div>
  </div>

</div>
</template>

<script>
  import FullSearch from './FullSearch'
  import apis from "@/api/apis";
  export default {
    name: "SearchList",
    components:{ FullSearch },
    data(){
      return{
        docTypes:[],
        searchList:[],
        loading: false,
        params:{
          page:1,
          page_size:20,
          keyword:'',
          docType:''
        },
        total:0,
        docTypeMap:{
          '1':'文档',
          '2':'API',
          '3':'公告'
        }
      }
    },
    mounted() {
      if(this.$route.params){
        this.params.keyword=this.$route.params.keyword
        this.params.docType=this.$route.params.docType || '1' // 1=文档，2=API，3=公告
        this.getSearchList()
      }
    },
    methods:{
      gotoDetail(row){
        if(this.params.docType === '1'){ // 文档
          this.$router.push(`/document/${row.cate_id}/article/${row.id}`)
        }
        if(this.params.docType === '2'){ // API
          this.$router.push(`/apiDocument/${row.cate_id}/document/${row.id}`)
        }
        if(this.params.docType === '3'){ // 公告
          this.$router.push(`/notice/${row.cate_id}/detail/${row.id}`)
        }
      },
      getSearchList(){
        this.loading = true
        apis.search.index(this.params).then(res => {
          this.docTypes = res.data.docTypes
          this.searchList = res.data.docPage.list
          this.total = Number(res.data.docPage.count)
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handleCurrentChange(page) {
        this.params.page = page
        this.getSearchList()
      }
    }
  }
</script>

<style lang="scss" scoped>
.top{
  width: 100%;
  height: 200px;
  background: #1E1E28;
  padding-top: 80px;
}
.search-list{
  width: 100%;
  background: #FAFAFA;
  .tabs-container{
    background: #FFFFFF;
    width: 100%;
  }
  .tabs{
    width: 1280px;
    margin: auto;
  }
  .list{
    width: 1280px;
    background: #FFFFFF;
    margin:16px auto 0;
    padding: 32px;
    min-height: 500px;
    .result{
      font-size: 14px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.45);
      line-height: 20px;
    }
    .row{
      margin-top: 32px;
      cursor: pointer;
      .search-title{
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; //多行在这里修改数字
        -webkit-box-orient: vertical;
        &:hover{
          color: #0B4FFC;
        }
      }
      .search-desc{
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 20px;
        margin-top: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3; //多行在这里修改数字
        -webkit-box-orient: vertical;
      }
      .search-time{
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        margin-top: 8px;
        span{
          margin-right: 10px;
        }
      }
    }
  }
}
.pagination {
  width: 1280px;
  margin: 10px auto;
  padding: 0px 10px;
  text-align: right;
}
::v-deep.tabs {
  background: #fff;
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__item.is-active {
    color: #1E1E28;
    font-weight: 500;
    font-size: 14px;
    border-bottom: 4px solid #000 ;
  }
  .el-tabs__active-bar {
    display: none;
  }
  .el-tabs__item{
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.45);
    padding: 0;
    margin: 0 30px;
  }
  .el-tabs__item:hover {
    color: #1E1E28;
  }
  .el-tabs__header{
    width: 1280px;
    margin: auto;
    .el-tabs__nav-wrap{
      padding: 20px 20px 0;
    }
    .el-tabs__nav-next, .el-tabs__nav-prev {
      top: 0;
      line-height: 60px;
      i{
        font-weight: bold;
        font-size: 16px;
        color: #1E1E28;
        &:hover{
          color: #000;
          transform: scale(1.1);
        }
      }

    }
  }
  .el-tabs__content{
    display: none;
  }

}
</style>
